jQuery.noConflict();
(function( $ ) {

	/* 
	-------------------------------------
	DOCUMENT READY
	-------------------------------------
	*/
	
	$(document).ready(function(){
		
		$('#new-arrivals .right').slick({
			autoplay: false,
			autoplaySpeed: 5000,
			appendArrows: '#new-arrivals .right .prev-next',
			prevArrow: '#new-arrivals .right .prev-next .prev',
			nextArrow: '#new-arrivals .right .prev-next .next',
			dots: true,
			dotsClass: 'paging',
			slide: '.slide',
			customPaging: function(slider, i) {
            	return '<div class="diamond"></div>';
        	},
        	responsive: [
	        	{
		        	breakpoint: 416,
		        	settings: {
			        	dots: false
		        	}
	        	}
        	]		
		});
		
		$('.best-gallery').slick({
			autoplay: false,
			appendArrows: '#best-sellers .gallery-nav',
			prevArrow: '.gallery-nav .prev',
			nextArrow: '.gallery-nav .next',
			dots: false,
			slide: '.best-gallery .single-product',
			slidesToShow: 4,
			slidesToScroll: 1,
			responsive: [
				{
					breakpoint: 961,
					settings: {
						slidesToShow: 3
					}
				},
				{
					breakpoint: 801,
					settings: {
						slidesToShow: 2
					}
				},
				{
					breakpoint: 551,
					settings: {
						slidesToShow: 1
					}
				}
			]
		});
		
		// Skip Banner
		$('.skip-arrow').click(function(event){
			var skipOffset = $('#new-arrivals').offset().top;
			event.preventDefault();
			$("html, body").animate({ scrollTop: skipOffset }, 1000);
		});
		
		/* 
		-------------------------------------
		MOBILE HOMEPAGE BUTTON TRANSITIONS
		-------------------------------------
		*/
		
			/* 
			-------------------------------------
			BEST SELLERS
			-------------------------------------
			*/
			
			$("#best-sellers .gallery-nav .next").on('touchstart', function() {
				$(this).css('background','#f82b7c');
				$("#best-sellers .gallery-nav .next span").css('color','#ffffff');			
			});
	
			$("#best-sellers .gallery-nav .next").on('touchend', function() {
				setTimeout((function() {
					$("#best-sellers .gallery-nav .next").css('background','transparent');	
					$("#best-sellers .gallery-nav .next span").css('color','#f82b7c');
				}), 250);
			});
			
			$("#best-sellers .gallery-nav .prev").on('touchstart', function() {
				$(this).css('background','#f82b7c');		
				$("#best-sellers .gallery-nav .prev span").css('color','#ffffff');		
			});
	
			$("#best-sellers .gallery-nav .prev").on('touchend', function() {
				setTimeout((function() {
					$("#best-sellers .gallery-nav .prev").css('background','transparent');	
					$("#best-sellers .gallery-nav .prev span").css('color','#f82b7c');
				}), 250);					
			});
			
			/* 
			-------------------------------------
			BLOG POSTS
			-------------------------------------
			*/
			
			$("#culture .posts .single-post").on('touchstart', function() {
				$("#culture .posts .single-post .post-img .overlay").css('opacity','0');
				$("#culture .posts .single-post h3 a").css('color','#ffffff');		
			});
		
	});

})(jQuery);